import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const textareaRootFn = /* @__PURE__ */ createRecipe('textarea-root', {}, [])

const textareaRootVariantMap = {}

const textareaRootVariantKeys = Object.keys(textareaRootVariantMap)

export const textareaRoot = /* @__PURE__ */ Object.assign(memo(textareaRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'textareaRoot',
  __getCompoundVariantCss__: textareaRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: textareaRootVariantKeys,
  variantMap: textareaRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, textareaRootVariantKeys)
  },
  getVariantProps: textareaRootFn.getVariantProps,
})